import React, { useEffect, useState } from "react";
import aboutPowerImg from "../../assets/media/ImageAnekant/about-power.png";

function Counter({ end, label, suffix = "" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1500;
    const increment = Math.ceil(end / (duration / 20));

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 20);

    return () => clearInterval(timer);
  }, [end]);

  return (
    <div className="col-md-6 col-lg-3 text-center">
      <div className="stat-card shadow-sm">
        <h2 className="fw-bold text-primary">
          {count}
          {suffix}
        </h2>
        <p className="text-muted mb-0">{label}</p>
      </div>
    </div>
  );
}

function AboutUs() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="about-hero py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <h1 className="fw-bold mb-3">
                About <span className="text-primary">Power Industry Digital Platform</span>
              </h1>
              <p className="lead text-muted">
                India’s structured digital platform for Cogeneration, Power
                Generation, Renewable Energy Plants and Agencies.
              </p>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src={aboutPowerImg}
                alt="Power Industry"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ================= INTRO ================= */}
      <section className="py-5 bg-light">
        <div className="container">
          <h3 className="fw-semibold mb-3">Who We Are</h3>
          <p className="text-muted">
            Power Industry digital platform is a data-driven platform focused on
            organizing and presenting verified information of power plants,
            renewable projects, and energy agencies across India. Our goal is to
            simplify industry discovery through structured, searchable, and
            reliable data.
          </p>
        </div>
      </section>

      {/* ================= STATISTICS ================= */}
      <section className="py-5">
        <div className="container">
          <h3 className="fw-semibold mb-4 text-center">
            Industry at a Glance
          </h3>

          <div className="row g-4">
            <Counter end={365} label="Cogeneration Plants" />
            <Counter end={27} label="Power Generation Units" />
            <Counter end={136} label="Renewable Energy Projects" />
            <Counter end={33} label="Energy Agencies Listed" />
          </div>
        </div>
      </section>

      {/* ================= COVERAGE ================= */}
      <section className="py-5 bg-light">
        <div className="container">
          <h3 className="fw-semibold mb-4">Our Coverage</h3>

          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <h6 className="fw-bold">Cogeneration</h6>
                  <p className="text-muted mb-0">
                    Sugar & industrial cogeneration power plants.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <h6 className="fw-bold">Power Generation</h6>
                  <p className="text-muted mb-0">
                    Thermal and conventional power stations.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <h6 className="fw-bold">Renewable Energy</h6>
                  <p className="text-muted mb-0">
                    Solar, wind and hybrid renewable projects.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <h6 className="fw-bold">Agencies</h6>
                  <p className="text-muted mb-0">
                    MNRE-approved & private energy agencies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOOTER NOTE ================= */}
      <section className="py-4">
        <div className="container text-center">
          <p className="text-muted mb-0">
            Power Industry Digital Platform – Structured Data for the Energy Sector
          </p>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
